import {
  AfterContentChecked,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { SdsDialogConfig, SelectionPanelModel } from '@gsa-sam/components';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NavigationConfig } from './navigation.config';
import { environment } from 'environment';
import { filter } from 'rxjs';

@Component({
  selector: 'sam-frontend-admin-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit, OnChanges {
  moduleData: SelectionPanelModel = NavigationConfig.getNavigationPanelConfig();
  selectedPanel: any;
  responsiveDialogOptions: SdsDialogConfig = {
    ariaLabel: 'Search Filters',
  };

  showLargeDownLoadsFlag: string = environment.SHOW_LARGEDOWNLOAD;
  showEmailSettingsFlag: string = environment.SHOW_EMAIL_SETTINGS;
  redirectPath: string;
  windowRef: any = window;
  @Input() isGov;

  constructor(public router: Router, private activatedRoute: ActivatedRoute) {
    // Intentionally blank. Comment is here to satisfy SonarQube
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isGov) {
      this.moduleData = NavigationConfig.getNavigationPanelConfig();
      this.showLargeDownLoadsFlag = this.isGov
        ? environment.SHOW_LARGEDOWNLOAD
        : 'false';
      this.checkAndRemoveNavigationLinks();
    }
  }

  ngOnInit(): void {
    this.checkAndRemoveNavigationLinks();
    this.selectInitialPanel();
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(event => {
      this.setPanel(this.windowRef.location.pathname);
    } )
  }

  checkAndRemoveNavigationLinks() {
    //left below commented line for future reference of child level filtering
    //this.moduleData.navigationLinks = this.moduleData.navigationLinks.filter(na => na.showlink === 'true').map( na =>({...na, children: na.children.filter(ch => ch.showlink == 'true')}));
    let profileIndex: any;
    if (this.showLargeDownLoadsFlag === 'false') {
      const largeDownLoadsIndex = this.moduleData.navigationLinks.findIndex(
        (obj) => {
          return obj.id === 'largeDownloads';
        }
      );
      if(largeDownLoadsIndex > -1) //if index does not exist
        this.moduleData.navigationLinks.splice(largeDownLoadsIndex, 1);
    }
  }
  /**
   * @name changeModule
   * @type Event - triggered by while changing new  module or page
   * @param event - passing event value to selected panel and navigating to the route with query params
   */
  changeModule(event: any) {
    if (event.id === 'profile') {
      const elem: any = document.querySelectorAll('.usa-current');
      if (elem && elem[0]) elem[0].blur();
    } else {
      this.selectedPanel = event;
      this.router.navigate([event.route]);
    }
  }
  /**
   * @name selectInitialPanel
   * @type Event - triggered by changing url
   * @param event - selecting panel according to the current path
   */
  selectInitialPanel() {
    let path = this.windowRef.location.pathname;
    if (path === '/') this.selectedPanel = this.moduleData.navigationLinks[0];
    else if (path.startsWith('/following'))
      this.selectedPanel = this.moduleData.navigationLinks[4].children[2];
    else if (path.startsWith('/downloads'))
      this.selectedPanel = this.moduleData.navigationLinks[4].children[3];
  }

   /**
   * @name setPanel
   */
   setPanel(urlPath: string) {
    let path = urlPath ? urlPath : this.windowRef.location.pathname;

    if (path === '/') 
      { this.selectedPanel = this.moduleData.navigationLinks[0]; }
    else if( path.includes('email-settings') ) 
      {
        this.selectedPanel = this.moduleData.navigationLinks.find(({text}) => text.includes("Email Settings") );
      }
    else if( path.includes('downloads') ) 
      {
        this.selectedPanel = this.moduleData.navigationLinks.find(({text}) => text.includes("Large Downloads") );
      }
    else if( path.includes('terms-of-use') ) 
      {
        this.selectedPanel = this.moduleData.navigationLinks.find(({text}) => text.includes("Terms of Use") );
      }
    else if( path.includes('following') ) 
      {
        this.selectedPanel = this.moduleData.navigationLinks.find(({text}) => text.includes("Followed Records") );
      }
    else if( path.includes('account-details') ) 
      {
        this.selectedPanel = this.moduleData.navigationLinks.find(({text}) => text.includes("Account Details") );
      }
    else if( path.includes('roles') ) 
      {
        this.selectedPanel = this.moduleData.navigationLinks.find(({text}) => text.includes("Roles") );
      }

    
  }
}
